module.exports = __webpack_public_path__ + "img/10_64.8af7e02c.png";